import classNames from 'classnames';
import * as React from 'react';
import { useRef } from 'react';

import { useExperimentAwareUrl } from '../../../Experimentation/Components/ResolveExperimentId';
import { renderInfoLabel } from '../../../ReactComponents/InfoLabel/InfoLabel';
import { ResponsivePicture } from '../../../ReactComponents/ResponsivePicture/ResponsivePicture';
import { withPromotionImpression } from '../../../Tracking/GoogleTagManager/PromotionImpression/WithPromotionImpression';
import { DiscountVariant } from '../../DiscountVariant.csharp';
import { BannerBackgroundVariant } from '../../MainBanner/BannerBackgroundVariant.csharp';
import { TextColor } from '../../TextColor.csharp';
import { WideImageBannerProps } from './WideImageBannerProps.csharp';

function WideImageBanner(props: WideImageBannerProps) {
    const {
        model: {
            image,
            backgroundVariant,
            description,
            heading,
            link,
            showLinkIcon,
            textColor,
            openInNewTab,
            isLazyLoaded,
            showTitleBackground,
            label,
            discount
        },
        profile
    } = props;

    const classNamesList = classNames(
        'WideImageBanner',
        showLinkIcon && 'WideImageBanner--LinkIcon',
        `WideImageBanner--${BannerBackgroundVariant[backgroundVariant]}`,
        `WideImageBanner--Color${TextColor[textColor]}`,
        showTitleBackground && heading && 'WideImageBanner--WithTitleBackground',
        image && 'WideImageBanner--WithImage'
    );

    const contentRef = useRef(null);

    const expLink = useExperimentAwareUrl(link, contentRef);

    return (
        <div ref={contentRef} className={classNamesList}>
            <a className="WideImageBanner__Inner" href={expLink} target={openInNewTab ? '_blank' : '_self'} rel="noreferrer">
                {image !== null && (
                    <div className="WideImageBanner__Picture">
                        <ResponsivePicture profile={profile} model={image} isLazyLoaded={isLazyLoaded} />
                    </div>
                )}

                <div className="WideImageBanner__Content">
                    <div className="WideImageBanner__ContentInner">
                        {heading && <h3 className="WideImageBanner__Heading">{heading}</h3>}
                        {description && <span className="WideImageBanner__Description">{description}</span>}
                    </div>
                </div>

                {renderInfoLabel(discount, DiscountVariant.Small, label)}
            </a>
        </div>
    );
}

export default withPromotionImpression(WideImageBanner);
